// extracted by mini-css-extract-plugin
export default {"sandboxContainer":"Sandbox_sandboxContainer__7ikFG","pickComponentContainer":"Sandbox_pickComponentContainer__ni46Y","curtainButton":"Sandbox_curtainButton__n06ZK"};